<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputPayment" });
import "tailwindcss/tailwind.css";
import { Span } from "../../../../typography/index.js";
import { percentage } from "../../../../common/format.js";
export let payments;
</script>

{#if payments}
    <ul class = 's8-payment-list'>
        {#each payments as payment}
            <li>
                <Span css = 'inline-block text-dark'>
                    { percentage(payment.rate) }
                </Span>
                {#if payment.due !== 0 }
                    { Math.abs(payment.due) } day{ Math.abs(payment.due) === 1 ? '' : 's' }
                {/if}
                <Span style = 'semibold'>
                        {#if payment.due > 0} after
                        {:else if payment.due === 0} on
                        {:else} before {/if}
                </Span>
                <Span
                    label = { `resource.auction.properties.payment.on.options.${ payment.on }` }
                />
            </li>
        {/each}
    </ul>
{/if}

<style>
    ul.s8-payment-list li {
    font-size: 0.75rem;
    line-height: 1rem
}</style>